import { SearchFieldKeys, TableColumn, licenceTypeOption } from "@sso/types";

export const licenceTableColumns: TableColumn<string>[] = [
  {
    name: "Product",
    field: "SoftwareLicence.Software.Name",
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Licence",
    field: "SoftwareLicence.Name",
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Organisation",
    field: "Organisation.Name",
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Issued",
    field: "CreateDate",
  },
  {
    name: "Updated",
    field: "UpdateDate",
  },
  {
    name: "Expiry date",
    field: "ExpiryDate",
    sortable: true,
  },
  {
    name: "Licence type",
    field: "Type",
    sortable: true,
    search: { type: SearchFieldKeys.SELECT, options: licenceTypeOption },
  },
  {
    name: "User/ No. of users",
    field: "User",
    sortable: false,
  },
];
